export const buildDataGridCellId = ({ gridName, columnId, row, primaryKey }) => {
  const primaryValue = primaryKey ? row?.[primaryKey] : undefined;
  const hasPrimaryValue =
    primaryValue !== undefined &&
    primaryValue !== null &&
    String(primaryValue).trim() !== "";
  const suffix = hasPrimaryValue ? primaryValue : row?.id;

  return `${gridName}-${columnId}-${suffix}`;
};
